document.addEventListener("DOMContentLoaded", function() {
    function scrollToConfirmation(element) {
        setTimeout(function() {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }, 100);
    }

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {

                        if (node.classList.contains('gform_confirmation_message') || node.id.includes('gform_confirmation_wrapper')) {
                            scrollToConfirmation(node);
                        }

                        else if (node.querySelector('.gform_confirmation_message')) {
                            let target = node.querySelector('.gform_confirmation_message');
                            scrollToConfirmation(target);
                        }
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});
